import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { ErrorType } from '../Enums/ErrorType.enum';

export class DirectoryProbeErrorResult<T extends EMode = EMode.entity> {
  /** Alias: type */
  type?: ErrorType;

  __typename?: string;
}

const fields: FieldDefinitions<DirectoryProbeErrorResult> = {
  type: {
    alias: 'type',
  },
  __typename: {
    alias: '__typename',
  },
};

export const directoryProbeErrorResultEntityDefinition: EntitiyDefinition<DirectoryProbeErrorResult> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'DirectoryProbeErrorResult',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
